import * as React from 'react';
import Modal, { ModalSize } from '../misc/components/modal';
import { Route } from 'react-router-dom';
import { EcgSiteView } from './EcgSiteView';

export const EcgSessionScreen = () => {
    return (
        <>
            <Route path="/ecg/:sessionId+">
                <Modal size={ModalSize.ExtraLarge} show={true}>
                    <div className="modal-body">
                        <EcgSiteView />
                    </div>
                </Modal>
            </Route>
        </>
    );
}

export default EcgSessionScreen;
